import { ListBox } from '@components/list-box'

customElements.define('kiss-list-box', ListBox)
